import React, { useState, useEffect, createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';

// Create a context for Stripe
const StripeContext = createContext(null);

// Get the Stripe publishable key from environment variables
const stripePublishableKey = import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY;

// Initialize Stripe promise only if the key is available
const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

const StripeProvider = ({ children }) => {
  const [stripeReady, setStripeReady] = useState(false);

  useEffect(() => {
    if (!stripePublishableKey) {
      // eslint-disable-next-line no-console
      console.info('Stripe: No publishable key configured. Payment features will be disabled.');
    } else {
      setStripeReady(true);
    }
  }, []);

  return (
    <StripeContext.Provider value={{ stripeReady, stripePromise }}>
      {children}
    </StripeContext.Provider>
  );
};

// Custom hook to use Stripe context
export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (context === undefined) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};

export { StripeProvider };
